'use strict';

var React = require('react'),
    _ = require('underscore'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    ShareTypes = require('../constants/ShareTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var ShareAddButtons = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    split: PropTypes.bool,
    round: PropTypes.bool,
    fill: PropTypes.bool,
    overlay: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    showMore: PropTypes.bool,
    showShare: PropTypes.bool,
    addLabel: PropTypes.string,
    onShareClick: PropTypes.func.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onMoreClick: PropTypes.func,
    primaryServices: PropTypes.arrayOf(
      PropTypes.oneOf(_.values(ShareTypes))
    )
  },

  getDefaultProps() {
    return {
      size: 'medium',
      round: false,
      split: false,
      primaryServices: []
    };
  },

  getCSSModifiers() {
    return [this.props.size];
  },

  render() {
    var addIconSize = this.props.size === 'medium' ? 'xsmall' : 'small';

    return (
      <div className={this.getClassName()}>
        <BtnGroup>
          <Button size={this.props.size}
                  color={this.props.color}
                  round={this.props.round && !this.props.addLabel}
                  split={this.props.split}
                  fill={this.props.fill}
                  overlay={this.props.overlay}
                  context={this.props.context}
                  onClick={this.props.onAddClick}>
            <Icon name='plus'
                  mode='stroke'
                  size={addIconSize} />
            {this.props.addLabel}
          </Button>

          {this.renderPrimaryServiceButtons()}

          {this.props.showShare &&
            <Button size={this.props.size}
                    color={this.props.color}
                    round={this.props.round}
                    split={this.props.split}
                    fill={this.props.fill}
                    overlay={this.props.overlay}
                    context={this.props.context}
                    onClick={this.props.onShareClick}>
              <Icon name='share'
                    mode='stroke'
                    size='small' />
            </Button>
          }

          {this.props.showMore &&
            <Button size={this.props.size}
                    color={this.props.color}
                    round={this.props.round}
                    split={this.props.split}
                    overlay={this.props.overlay}
                    context={this.props.context}
                    onClick={this.props.onMoreClick}>
              <Icon name='more'
                    mode='fill'
                    size='small' />
            </Button>
          }
        </BtnGroup>
      </div>
    );
  },

  renderPrimaryServiceButtons() {
    return this.props.primaryServices.map(service =>
      <Button key={service}
              size={this.props.size}
              color={service.toLowerCase()}
              round={this.props.round}
              split={this.props.split}
              fill={this.props.fill}
              overlay={this.props.overlay}
              context={this.props.context}
              onClick={_.partial(this.props.onShareClick, _, service)}>
        <Icon name={service.toLowerCase()}
              mode='fill'
              size='small' />
      </Button>
    );
  }
});

module.exports = ShareAddButtons;



/** WEBPACK FOOTER **
 ** ./molecules/ShareAddButtons.jsx
 **/